module.exports = __webpack_public_path__ + "assets/img/38_446.0fb07f4d.jpg";